import { useEffect } from "react";

export const useFavicon = (faviconUrl?: string) => {
  useEffect(() => {
    if (!faviconUrl) return;

    let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");

    if (!link) {
      link = document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = faviconUrl;
      document.getElementsByTagName("head")[0].appendChild(link);
    } else {
      link.href = faviconUrl;
    }

    return () => {
      if (link) {
        link.href = "";
      }
    };
  }, [faviconUrl]);
};
